import styles from './PermissionModal.module.css';


const PermissionModal = ({setUserModalPage, modalProps}) => {
    const handlePermissionButtonClicked = () =>{
        localStorage.setItem('isPermChecked', true);
        if(modalProps.isFirst)
            window.flutter_inappwebview.callHandler('CustomChannel', 'REQUEST_FIRST_PERMISSION');
        else
            window.flutter_inappwebview.callHandler('CustomChannel', 'REQUEST_PERMISSION');

        if(!modalProps.isFirst)
            setUserModalPage(0);
    };

    const handleBackButtonClicked = () => {
        setUserModalPage(0);
    };

    return (
        <div className={styles.container}>
                <div className={styles.contents}>
                    <div className={styles.hedaer}>
                            <div className={styles.mainheaderParent}>
                                <b className={styles.mainheader}>
                                        <span>권한 허용</span>
                                        <span className={styles.span}>이 꼭 필요해요 🙂</span>
                                </b>
                                <div className={styles.subheader}>
                                        <p className={styles.hotple}>HOTPLE의 핵심 기능을 이용하기 위해</p>
                                        <p className={styles.hotple}>아래 2가지 권한을 허용해주세요!</p>
                                </div>
                            </div>
                            <div className={styles.frameParent}>
                                <div className={styles.permissionParent}>
                                        <div className={styles.permission}>
                                            <img className={styles.iconmyLocation} alt="" src="images/my_location.svg" />
                                            <div className={styles.div}>위치 권한</div>
                                        </div>
                                        <div className={styles.parent}>
                                            <div className={styles.pick}>· 위치 기반 핫플 찾기</div>
                                            <div className={styles.pick}>· 내 주변 핫플 추천</div>
                                        </div>
                                </div>
                                <div className={styles.permissionParent}>
                                        <div className={styles.permission}>
                                            <img className={styles.iconmyLocation} alt="" src="images/notification.svg" />
                                            <div className={styles.div}>알림 권한</div>
                                        </div>
                                        <div className={styles.parent}>
                                            <div className={styles.pick}>· AI스크랩 완료 알림</div>
                                            <div className={styles.pick}>· 친구가 날 태그한 핫플</div>
                                            <div className={styles.pick}>· 이벤트 결과 알림</div>
                                        </div>
                                </div>
                            </div>
                    </div>
                    <div className={styles.buttons}>
                            {!modalProps.isFirst &&
                            <div className={styles.cancleButton} onClick={() => handleBackButtonClicked()}>
                                <div className={styles.text}>돌아가기</div>
                            </div>
                            }
                            <div className={styles.deleteButton} onClick={() => handlePermissionButtonClicked()}>
                                <img className={styles.iconsetting} alt="" src="images/setting.svg" />
                                <div className={styles.div}>허용하기</div>
                            </div>
                    </div>
                </div>
        </div>
    );
};

export default PermissionModal;